export const PROPERTY_TYPE_APARTMENT = 'APARTMENT';
export const PROPERTY_TYPE_HOME = 'SINGLE_FAMILY_HOME';
export const PROPERTY_TYPE_OFFICE = 'COMMERCIAL';
export const PROPERTY_TYPE_TOWNHOUSE = 'MULTI_FAMILY_HOME';
export const PROPERTY_TYPE_STORAGE = 'STORAGE';
export const PROPERTY_TYPE_OTHER = 'OTHER';

export const typeOptions = {
  type: [
    { label: 'Apartment/Condo', value: PROPERTY_TYPE_APARTMENT },
    { label: 'Home', value: PROPERTY_TYPE_HOME },
    { label: 'Office', value: PROPERTY_TYPE_OFFICE },
    { label: 'Townhouse', value: PROPERTY_TYPE_TOWNHOUSE },
    { label: PROPERTY_TYPE_STORAGE, value: PROPERTY_TYPE_STORAGE },
    { label: 'Other', value: PROPERTY_TYPE_OTHER },
  ],
  garage: [
    { label: 'No Garage', value: '0' },
    { label: '1 Car Garage', value: '1' },
    { label: '2 Car Garage', value: '2' },
    { label: '3 Car Garage', value: '3' },
    { label: '4 Car Garage', value: '4' },
    { label: '5+ Car Garage', value: '5' },
  ],
  spaces: [
    { label: 'N/A', value: 'NONE' },
    { label: 'Attic', value: 'ATTIC' },
    { label: 'Basement', value: 'BASEMENT' },
    { label: 'Attic & Basement', value: 'ATTIC BASEMENT' },
  ],
  stories: [
    { label: '1 Story', value: '1' },
    { label: '2 Stories', value: '2' },
    { label: '3 Stories', value: '3' },
    { label: '4+ Stories', value: '4' },
  ],
  rooms: [
    { label: '1 bedroom', value: '1' },
    { label: '2 bedrooms', value: '2' },
    { label: '3 bedrooms', value: '3' },
    { label: '4 bedrooms', value: '4' },
    { label: '5 bedrooms', value: '5' },
    { label: '6+ bedrooms', value: '6' },
  ],
  aptRooms: [
    { label: 'Studio', value: '0' },
    { label: '1 bedroom', value: '1' },
    { label: '2 bedrooms', value: '2' },
    { label: '3 bedrooms', value: '3' },
    { label: '4 bedrooms', value: '4' },
    { label: '5 bedrooms', value: '5' },
    { label: '6+ bedrooms', value: '6' },
  ],
  unitSize: [
    { label: '5x5', value: '25' },
    { label: '5x10', value: '50' },
    { label: '5x15', value: '75' },
    { label: '10x10', value: '100' },
    { label: '10x15', value: '150' },
    { label: '10x20', value: '200' },
    { label: '10x25', value: '250' },
    { label: '10x30', value: '300' },
  ],
  elevator: [
    { label: 'Yes, reserved', value: 'TRUE_RESERVED' },
    { label: 'Yes, not reserved', value: 'TRUE_NOT_RESERVED' },
    { label: 'No', value: 'FALSE' },
  ],
  reservedParking: [
    { label: 'Yes', value: 'TRUE' },
    { label: 'No', value: 'FALSE' },
  ],
  area: [
    { label: '1 - 1,000', value: '1000' },
    { label: '1,001 - 2,000', value: '2000' },
    { label: '2,001 - 3,500', value: '3500' },
    { label: '3,501 - 5,000', value: '5000' },
    { label: '5,001+', value: '5001' },
  ],
  areaCommerical: [
    { label: '1 - 1,000', value: '1000' },
    { label: '1,001 - 2,000', value: '2000' },
    { label: '2,001 - 3,000', value: '3000' },
    { label: '3,001 - 4,000', value: '4000' },
    { label: '4,001+', value: '4001' },
  ],
  longWalkToTruck: [
    { label: '<50 yards', value: 'false' },
    { label: '>50 yards', value: 'true' },
  ],
};

export const displayFieldTypes = {
  unit: [
    { name: PROPERTY_TYPE_APARTMENT, required: false },
    { name: PROPERTY_TYPE_TOWNHOUSE, required: false },
  ],
  squareFootage: [
    { name: PROPERTY_TYPE_APARTMENT, required: true },
    { name: PROPERTY_TYPE_HOME, required: true },
    { name: PROPERTY_TYPE_TOWNHOUSE, required: true },
  ],
  floors: [
    { name: PROPERTY_TYPE_APARTMENT, required: true },
    { name: PROPERTY_TYPE_STORAGE, required: true },
  ],
  elevator: [
    { name: PROPERTY_TYPE_APARTMENT, required: true },
    { name: PROPERTY_TYPE_STORAGE, required: true },
  ],
  longWalkToTruck: [
    { name: PROPERTY_TYPE_APARTMENT, required: true },
    { name: PROPERTY_TYPE_HOME, required: true },
    { name: PROPERTY_TYPE_TOWNHOUSE, required: true },
    { name: PROPERTY_TYPE_STORAGE, required: true },
  ],
  stories: [
    { name: PROPERTY_TYPE_HOME, required: true },
    { name: PROPERTY_TYPE_TOWNHOUSE, required: true },
  ],
  unitSize: [{ name: PROPERTY_TYPE_STORAGE, required: true }],
};
